import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-coustom-select',
  templateUrl: './coustom-select.component.html',
  styleUrls: ['./coustom-select.component.scss']
})
export class CoustomSelectComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    this.data1 = this.data;
    this.selectedValue = this.data?.[0]
    this.selected.nativeElement.value = this.selectedValue?.name
    this.dropDownIcon = "hide"
    this.loadSelectTag()
  }
  @ViewChild('selected', { static: false }) selected: ElementRef;
  @ViewChild('inputValue', { static: false }) inputValue: ElementRef;
  @Input() data:any
  @Output() selectedCompany = new EventEmitter();
  data1:any[] = []
  selectedValue: any;
  dropDownIcon:any;
  containerHeight:any;
  ngOnInit(): void {
  }
  loadSelectTag() {
    let selectTag = document.getElementById("select")
    if (this.inputValue.nativeElement.value !== "") {
      selectTag.replaceChildren();
    }
    else {
      selectTag.replaceChildren();
    }
    this.data.forEach((val:any) => {
      this.containerHeight = 0
      let element = document.createElement("li")
      let elementText = document.createTextNode(val.name)
      element.style.cursor = "pointer"
      element.appendChild(elementText)
      selectTag.appendChild(element)
      element.addEventListener('click',  () => {
        // alert(JSON.stringify(val))
        this.selectedValue = val
        this.selected.nativeElement.value = this.selectedValue?.name
        this.inputValue.nativeElement.value = ""
        this.dropDownIcon = "hide"
        document.getElementById("container").style.display = "none"
        this.selectedCompany.emit(this.selectedValue)
      })
    })
    this.containerHeight = document.getElementById("select").clientHeight
  }
  filterData() {
    this.data = []
    if (this.inputValue.nativeElement.value !== "") {
      this.data = this.data1.filter((val) => {
        return val.name.toLowerCase().match(this.inputValue.nativeElement.value.toLowerCase())
      })
      this.loadSelectTag()
    }
    else {
      this.data = this.data1
      this.loadSelectTag()
    }
  }
  dropdownShowHide(data) {
    this.dropDownIcon = data
    if (data == "show") {
      document.getElementById("container").style.display = "block"
      this.data = this.data1
      this.loadSelectTag()
      this.containerHeight = document.getElementById("select").clientHeight
    }
    else {
      document.getElementById("container").style.display = "none"
    }
  }

}
